import React, { type ReactNode } from 'react';

import cx from '@travel/icons/_utils/classnames';

import styles from './reservationInfo.module.scss';

type Props = {
  title: JSX.Element | string;
  content: ReactNode;
  className?: string;
  headerClassName?: string;
};

const ReservationInfo = (props: Props) => {
  const { title, content, className, headerClassName } = props;
  return (
    <div className={cx(styles.container, className)}>
      <h4 className={cx(styles.header, headerClassName)}>{title}</h4>
      <span>{content}</span>
    </div>
  );
};

export default ReservationInfo;
